import { Stepper } from "@shared/components/Stepper";
import { useState } from "react";
import { MeterSelectionStep } from "./stepComponents/MeterStep";
import { ReviewStep } from "./stepComponents/ReviewStep";
import { ServiceDetailsStep } from "./stepComponents/ServiceDetails";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PageHeader } from "@shared/components/PageHeader";

export const CreateServiceOrder = () => {
  const [stepperData, setStepperData] = useState({});
  const remoteUtilityId = useRemoteUtilityId();
  const steps = [
    {
      title: "Service Details",
      slug: "service-details",
      description: "Select operation type, SOP, and priority",
      component: <ServiceDetailsStep remoteUtilityId={remoteUtilityId} />,
      infoDescription:
        "Choose the type of service operation you want to perform and set the priority level.",
    },
    {
      title: "Select Meters",
      slug: "select-meters",
      description: "Search and select meters for the service order",
      component: <MeterSelectionStep remoteUtilityId={remoteUtilityId} />,
      infoDescription:
        "Search for meters using filters and select the ones you want to include in this service order.",
    },
    {
      title: "Review & Create",
      slug: "review-create",
      description: "Review selections and create service orders",
      component: <ReviewStep remoteUtilityId={remoteUtilityId} />,
      infoDescription:
        "Review your selections and add any additional notes before creating the service orders.",
    },
  ];


  return (
    <div>
        <PageHeader
          title=" Create Service Order"
          subtitle=" Follow the steps to create a new service order"
        />

        {/* Stepper Component */}
        <Stepper
          steps={steps}
          onStepSave={() => {}}
          onStepChange={() => {}}
          onValidation={async () => ({ isValid: true })}
          onComplete={() => {}}
          autoSave={true}
          persistProgress={true}
          storageKey="create-service-order-progress"
          allowSkip={false}
          enableRouting={true}
          enableApiSave={true}
          saveOnStepChange={true}
          trackDirtyState={true}
          enableDraftMode={true}
          showDraftResume={true}
          allowStepClick={false}
          className="bg-white rounded-lg shadow-sm p-6"
        />
    </div>
  );
};

export default CreateServiceOrder;
